<template>
  <v-card>
    <v-card-title primary-title class="align-baseline d-block">
      <div class="headline">Historique</div>
      <v-layout row wrap>
        <v-flex xs11 sm5>
          <v-menu
            v-model="fromMenu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="from"
                label="Depuis"
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="from"
              type="month"
              no-title
              scrollable
              @input="reload()"
            />
          </v-menu>
        </v-flex>
        <v-flex xs11 sm5>
          <v-menu
            v-model="toMenu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="to"
                label="Jusqu'à"
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="to"
              type="month"
              no-title
              scrollable
              @input="reload()"
            />
          </v-menu>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="billing.history"
        :expand="false"
        item-key="_id"
      >
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded">
            <td>{{ new Date(props.item.date).toISOString().substr(0, 7) }}</td>
            <td>{{ props.item.total }}</td>
            <td>{{ props.item.projects.length }}</td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <BillDataTable :billing-entry="props.item" :paginate="false" />
        </template>
      </v-data-table>
    </v-card-title>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import BillDataTable from "../../components/billing/BillDataTable";

export default {
  name: "BillingHistory",
  components: { BillDataTable },
  data: function () {
    return {
      from: moment().subtract(6, "months").format("YYYY-MM"),
      to: moment().format("YYYY-MM"),
      fromMenu: false,
      toMenu: false,
      headers: [
        { text: "Date", value: "date" },
        { text: "Total", value: "total" },
        { text: "Nombre de projets", value: "projects.length" },
      ],
      subheaders: [
        { text: "Lien", sortable: false },
        { text: "Prénom", value: "firstName" },
        { text: "Nom", value: "lastName" },
        { text: "Montant", value: "amount" },
        { text: "Rôles", value: "roles" },
      ],
    };
  },
  beforeMount() {
    this.reload();
  },
  computed: {
    ...mapState("user", ["billing"]),
  },
  methods: {
    ...mapActions("user", ["billingHistory"]),
    async reload() {
      await this.billingHistory({ from: this.from, to: this.to });
    },
  },
};
</script>
